export default () => ({
  status: null,
  participants: [],
  startTaskDate: null,
  endTaskDate: null,
});
